<template>
  <div class="card h-100">
    <template v-if="state.repCode && !state.repCode._multi">
      <template v-if="state.repCode.code === 'UNASSIGNED' || state.repCode.code === null">
        <div class="card-header px-3 py-2">
          <i class="fas fa-tag mr-2"></i>
          <span class="font-weight-bold">Unassigned — {{nav.item}}</span>
        </div>
      </template>
      <template v-else>
        <div class="card-header px-3 py-2">
          <i class="fas fa-tag mr-2"></i>
          <span class="font-weight-bold"
                v-text="(state.repCode.label || state.repCode.code) + ' - ' + nav.item"></span>
        </div>
      </template>
      <div class="card-body pt-3">
        <ul class="nav nav-tabs">
          <li v-for="(item, i) in nav.items" :key="i" class="nav-item">
            <a class="nav-link"
               :class="nav.class(`active`, item)"
               v-on:click="nav.click(item)">
              <i :class="nav.class(`icon`, item)" class="mr-1"></i>
              <span v-text="item"></span>
            </a>
          </li>
        </ul>
        <template v-if="nav.item">
          <div class="component">
            <component :is="nav.component" :list="nav.list"></component>
          </div>
        </template>
      </div>
    </template>
    <template v-else-if="state.repCode && state.repCode._multi">
      <div class="card-header px-3 py-2">
        <i class="fas fa-tags mr-2"></i>
        <span class="font-weight-bold">{{state.repCode.codes.length}} RepCodes selected — {{nav.item}}</span>
      </div>
      <div class="card-body pt-3">
        <ul class="nav nav-tabs">
          <li v-for="(item, i) in nav.items" :key="i" class="nav-item">
            <a class="nav-link"
               :class="nav.class(`active`, item)"
               v-on:click="nav.click(item)">
              <i :class="nav.class(`icon`, item)" class="mr-1"></i>
              <span v-text="item"></span>
            </a>
          </li>
        </ul>
        <template v-if="nav.item">
          <div class="component">
            <component :is="nav.component" :list="nav.list"></component>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="card-header px-3 py-2">
        <i class="fas fa-tag mr-2"></i>
        <span class="font-weight-bold">RepCode</span>
      </div>
      <div class="card-body pt-3">
        <h5 class="text-center my-5">No RepCode selected</h5>
      </div>
    </template>
  </div>
</template>

<style scoped>
div.card-body h5 { opacity: 0.5; }
div.card-header i, div.card-header span { opacity: 0.7; }
li.nav-item { cursor: pointer; }
a.nav-link { color: #337cc5; }
a.nav-link.active i, a.nav-link.active span { opacity: 0.7; }
ul span, ul i { font-size: 0.9rem; }
div.component {
  height: calc(100vh - 225px);
  margin-top: 6px;
  margin-right: -15px;
  margin-bottom: -10px;
}
</style>

<script>
import { events, session } from "../../../../service";
import firmAccounts from "../custodian/accounts.vue";
import firmContracts from "../custodian/contracts.vue";
import firmInvoices from "../custodian/invoices.vue";

export default {
  name: `FirmRepCode`,
  get components() {
    return {
      firmAccounts,
      firmContracts,
      firmInvoices,
    };
  },
  data() {
    return {
      state: ``,
      nav: ``,
    };
  },
  watch: {
    "state.repCode": {
      handler() {
        if (this.nav && this.state.repCode) {
          this.nav.item = this.nav.state.item;
          this.nav.reload();
        }
      },
      deep: true,
    },
  },
  created() {
    this.init();
    var { nav } = this;
    this.events = events.$watch({
      nav: nav.event.bind(nav),
    });
  },
  destroyed() {
    events.$unwatch(this.events);
  },
  methods: {
    init() {
      var state = session.get(`state`);
      this.state = state;
      if (!state.hasOwnProperty(`nav`)) this.$set(state, `nav`, {});

      var nav = {
        _init: (o, k, v) => this.$set(o, k, v),
        _list() {
          var { item } = this;
          var lists = this._state(`lists`, []);
          var list = lists.find((o) => o.item == item);
          if (list) return list;
          lists.push({ item, search: ``, sort: { key: ``, asc: `` } });
          return this._list();
        },
        _refresh: () => new Promise((r) => this.$nextTick(r)),
        _state(k, v) {
          if (this.state.hasOwnProperty(k)) return this.state[k];
          this._init(this.state, k, v);
          return this._state(k);
        },
        get component() {
          return `firm-${this.item}`;
        },
        class(type, item) {
          switch (type) {
            case `active`:
              return item == this.item ? `active` : ``;
            case `icon`:
              switch (item) {
                case `Accounts`: return `fas fa-database`;
                case `Contracts`: return `far fa-file-alt`;
                case `Invoices`: return `fas fa-dollar-sign`;
                default: throw new Error(`Unable to determine icon for item, ${item}!`);
              }
            default:
              throw new Error(`Invalid class type, ${type}!`);
          }
        },
        click(item) {
          if (item == this.item) return this.reload();
          this.item = this.state.item = item;
        },
        event(e) {
          var item = this.items.find(
            (s) => s.toLowerCase() == e.data.toLowerCase()
          );
          if (item) this.click(item);
        },
        item: ``,
        get items() {
          return [`Contracts`, `Invoices`, `Accounts`];
        },
        get list() {
          return this._list();
        },
        async reload() {
          if (!this.item) return;
          var item = this.item;
          this.item = ``;
          await this._refresh();
          this.item = item;
        },
        get state() {
          // For multi-select, build a stable key from all selected codes.
          const repCodeKey = state.repCode?._multi
            ? `_multi:${state.repCode.codes.map((r) => r.code ?? '').sort().join(',')}`
            : (state.repCode?.code ?? ``);
          if (!state.nav.repcodes) this._init(state.nav, `repcodes`, []);
          var s = state.nav.repcodes.find((s) => s.repCodeKey == repCodeKey);
          if (!s) {
            state.nav.repcodes.push({ repCodeKey, item: this.items[0] });
            return this.state;
          }
          return s;
        },
        init() {
          if (!state.nav.repcodes) this._init(state.nav, `repcodes`, []);
          if (state.repCode) this.item = this.state.item;
          return this;
        },
      };
      this.nav = nav.init();
    },
  },
};
</script>
